<template>
  <div class="videoonlinecourse">
		<div class="contentTop">
			<banner></banner>
			<!-- <product></product> -->
			
			<div class="contentMiddle">
				<headerview></headerview>
				<div class="con_all">
					<div class="con_all_one">
						<tipsign :titleName="'网络视频课程'"></tipsign>
					</div>
					<div class="con_all_two">
						<div class="two_left">
							<div class="videocar">
								<video :src="$fileAccessHttpUrl(informData.videoUrl_dictText)"  controls="controls"></video>
							</div>
							 <!-- <div class='videocar'>
								<video-player class="video-player vjs-custom-skin"
									  ref="videoPlayer"
									  :playsinline="true"
									  :options="playerOptions">
								</video-player>
							</div> -->
							
							<div class="text_a">
								{{informData.title}}
							</div>
							<div class="text_b">
								<span>作者：{{informData.createBy_dictText || ''}}</span>
								<span>发布时间：{{informData.createTime || ''}}</span>
								<span>浏览次数:{{informData.viewCount || ''}}次</span>                 
							</div>
							<div class="text_c" v-if="false">
								<textarea style="resize:none;"></textarea>
								<div class="tjcar">
									<div class="tjbtn">
										提问
									</div>
								</div>
							</div>
							<div style="font-size: 0.14rem;height: 0.6rem;line-height: 0.6rem;" v-if="false">全部评论</div>
							
							<div class="text_d" v-if="false">
								<div v-for="(item,index) in 3" class="blackcar" :key="index">
									<div class="imgcar">
										<img src="../../../static/index/topback@2x.png" alt=""/>
									</div>
									<div class="textcar">
										<div class="textcar_a">
											<span style="color: #F65858;font-size: 0.14rem;">Mrisy: </span>
											<span style="color: #606060;font-size: 0.14rem;">真的优秀少先队员，优秀少先队员优秀少先队员优秀少先队员</span>
										</div>
										<div class="termcon">
											<div v-for="(item,index) in 3" class="termcar" :key="index">
												<span style="color: #F65858;font-size: 0.14rem;">@Nily: </span> 
												<span style="color: #606060;font-size: 0.14rem;">你说的没错！！！</span> 
											</div>
										</div>
										
										<div class="textcar_b">
											<span style="color: #535353;font-size: 0.14rem;">6月23日  22:15</span>
											<div class="hfbtn">回复</div>
										</div>
									</div>
								</div>
							</div>
							
							<div class="text_e" v-if="false">
								<div class="plbtn">提交评论</div>
							</div>
							
						</div>
						<div class="two_right">
							<div class="textcar">
								<div class="textcar_a">课程详情</div>
								<div class="textcar_b">
									<!-- {{informData.introduction}} -->
									<div v-html="regImg(informData.introduction)"></div>
								</div>
							</div>
							<div class="img_span_con">
								<span>点赞:</span>
								<img style="margin-right: 1rem;" src="../../../static/index/thumbs_up_cur@2x.png" alt="" v-if="ifThumbsup"  @click="thumbsDown"/>
								<img style="margin-right: 1rem;" src="../../../static/index/thumbs_up@2x.png" alt="" v-if="!ifThumbsup" @click="thumbsup"/>
								<span>转发:</span>
								<img src="../../../static/index/micro_blog@2x.png" alt="" @click="share('sina')"/>
								<!-- <img src="../../../static/index/weChat@2x.png" alt="" @click="share('weixin')"/> -->
								<img src="../../../static/index/qq@2x.png" alt="" @click="share('qzone')"/>
							</div>
						</div>
					</div>
					
				</div>	
			</div>	
						
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>
import headerview from "../../../components/headerview/headerview.vue";
import tipsign from "../../../components/tipsign/tipsign.vue";
// import videoDome from './video.vue'
export default {
  components: {
		headerview,
		tipsign,
		// videoDome
  },
  
  data() {
		return {
			informData:{},
			id:"",
			ifThumbsup:false,
			
			playerOptions: {
				//播放速度
				playbackRates: [0.5, 1.0, 1.5, 2.0], 
				//如果true,浏览器准备好时开始回放。
				autoplay: false, 
				// 默认情况下将会消除任何音频。
				muted: false, 
				// 导致视频一结束就重新开始。
				loop: false, 
				// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				preload: 'auto', 
				language: 'zh-CN',
				 // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				aspectRatio: '16:9',
				 // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				fluid: true,
				sources: [{
					//类型
					type: "video/mp4",
					//url地址
					src: ''
					// src: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4' 
				}],
				//你的封面地址
				poster: '', 
				 //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				notSupportedMessage: '此视频暂无法播放，请稍后再试',
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
					//全屏按钮
					fullscreenToggle: true  
				}
			},
			
		};
  },
  
  mounted() {
		this.id = this.$route.query.id
		this.getYouthteamDetail();
		this.ifthumbsup();
  },
  
  created(){
	  
  },
  
  methods: {
	  regImg(newContent){//富文本图片处理
			if(newContent){
				newContent = newContent.replace(/\<img/gi,'<img style="max-width:100%; width:100%;height:auto;display:block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi,'<video style="max-width:100%; width:100%;height:auto;display:block;margin:10rpx auto;"');
				if(newContent.indexOf('<table')!=-1){
					newContent.replace(/\<table/gi,'<table borer="1"')
				}
				 
			}
			
			return newContent;
	    },
	  //是否点赞
	  ifthumbsup(){
		  this.$get(`web/encourage/check?businessId=${this.id}&type=1`).then(res=>{
			  if(res.success){
					console.log(res)	
					this.ifThumbsup = res.result				
			  }
		  })
	  },
	  thumbsDown(){//取消点赞
		let param = {
				businessId: this.id,
				type: 1,
		  };		  		  
		  this.$get(`web/encourage/cancel`,param).then(res=>{
			  if(res.success){
					// console.log(res)
					  this.$message({
						  message: '取消点赞成功',
						  type: 'Warning'
					 });
					 this.ifThumbsup = false;
			  }
		  })  
	  },
	  //点赞
	  thumbsup(){
		  let param = {
				businessId: this.id,
				type: 1,
		  };		  		  
		  this.$post(`web/encourage/add`,param).then(res=>{
			  if(res.success){
					// console.log(res)
					 this.$message({
						  message: '点赞成功',
						  type: 'success'
					 });
					 this.ifThumbsup = true;
			  }
		  })  		 
	  },
	  
		//少年队网络视频
		getYouthteamDetail(){
			  var self = this;
			  this.$get(`web/teaching/queryById?id=${this.id}`).then(res=>{
				  if(res.success){
						console.log(res)	
						self.informData = res.result	
						self.playerOptions.sources[0].src = this.$fileAccessHttpUrl(res.result.videoUrl_dictText)
				  }
			  })
			  
		},
		
		share(type){								
			//qq空间分享接口
			if(type == 'qzone'){
				// window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='
				// +document.location.href+'?sharesource=qzone&title=标题&pics=图片地址&summary= 描述')
				
				window.open('https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='
				+document.location.href+'?sharesource=qzone&title=少先队&pics=图片地址&summary=描述')
			}
			//新浪微博接口的传参
			if(type=='sina'){
				window.open('http://service.weibo.com/share/share.php?url='
				+document.location.href+'?sharesource=weibo&title=少先队&pic=图片&appkey=微博平台申请的key');				

			}
			
			if(type=='weixin'){
				//微信分享
				// var url = window.location.href,
				// encodePath = encodeURIComponent(url),
				// targetUrl = 'http://qr.liantu.com/api.php?text=' + encodePath;
				// window.open(url,'weixin', 'height=320, width=320')
			}
			
		}
		
	  
  },
  
};
</script>

<style scoped lang="scss">
video{
    height: 100%;
    width: 100%;
}
	.videoonlinecourse{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 10.2rem;
			border: 1px solid #FFFFFF;
			
			.con_all{
				height: 13rem;	
				margin: 0.1rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				.con_all_one{
					height: 0.4rem;
					line-height: 0.4rem;
					padding-left: 0.2rem;
					border-bottom: 0.01rem solid #ededed;
				}
				.con_all_two{
					height: 11.5rem;
					// border: 1px solid red;
					display: flex;
					.two_left{
						flex: 2;
						// border: 1px solid red;
						margin: 0.2rem;
						.videocar{
							border: 0.01rem solid #ededed;
							height: 4.2rem;
							width: 100%;
							overflow: hidden;
							img{
								width: 100%;
								height: 100%;
							}
							.video{
								width: 100%;
								height: 100%;
							}
						}
						.text_a{
							font-size: 0.28rem;
							font-weight: bold;
							height: 0.6rem;
							line-height: 0.6rem;
						}							
						.text_b{
							font-size: 0.14rem;
							color: #666666;
							height: 0.4rem;
							line-height: 0.4rem;
							span{
								margin-right: 0.4rem;
							}
						}
						.text_c{
							margin-top: 0.5rem;
							width: 100%;
							height: 1.48rem;
							background: #F4F5F8;
							text-align: center;
							textarea{
								margin-top: 0.2rem;
								width: 95%;
								height: 0.84rem;
								background: #FFFFFF;
								border-radius: 3px;
							}
							.tjcar{
								width: 100%;
								.tjbtn{
									float: right;
									margin-right: 0.2rem;
									width: 0.74rem;
									height: 0.22rem;
									background: #FFFFFF;
									border-radius: 3px;
									text-align: center;
									line-height: 0.22rem;
									font-size: 0.12rem;
									font-weight: bold;
								}
							}
						}
						.text_d{
							height: 2.5rem;
							// border: 1px solid red;
							overflow-y: auto;
							.blackcar{
								display: flex;
								// height: 1rem;
								// border: 1px solid blue;
								padding-bottom: 0.3rem;
								border-bottom: 1px solid #ededed;
								.imgcar{
									width: 0.8rem;
									display: flex;
									// align-items: center;
									justify-content: center;
									img{
										width: 0.44rem;
										height: 0.44rem;
										border-radius: 50%;
									}
								}
								.textcar{
									flex: 1;
									.termcon{
										margin: 0.1rem;
										.termcar{
											width: 100%;
											height: 0.31rem;
											background: #F4F5F8;
										}
									}									
									.textcar_b{
										display: flex;
										justify-content: space-between;
										.hfbtn{
											width: 0.77rem;
											height: 0.24rem;
											line-height: 0.24rem;
											text-align: center;
											background: #ECEDF1;
											border-radius: 4px;
											font-size: 0.14rem;
											margin-right:0.2rem;
										}
									}
								}
							}
						}
						.text_e{
							height: 1rem;
							display: flex;
							margin-top: 0.5rem;
							.plbtn{
								width: 3.3rem;
								height: 0.5rem;
								line-height: 0.5rem;
								text-align: center;
								background: #E61F26;
								border-radius: 2px;
								font-size: 0.17rem;
								color: #FFFFFF;
							}
						}
					}
					.two_right{
						margin-top: 0.2rem;
						margin-right: 0.1rem;
						flex: 1;
						// border: 1px solid red;
						.textcar{
							padding: 0.2rem;
							width: 3.73rem;
							height: 4rem;
							overflow-x: hidden;
							overflow-y: auto;
							background: #F4F5F8;
							font-size: 0.18rem;
							// text-align: center;
							.textcar_a{
								text-align: center;
								font-weight: bold;
								margin-bottom: 0.3rem;
							}
							.textcar_b{
								
							}
						}
						
						.img_span_con{
							margin-top: 0.2rem;
							font-size: 0.18rem;
							font-weight: 400;
							height: 0.6rem;
							line-height: 0.6rem;
							img{
								height: 0.33rem;
								width: 0.31rem;
								margin-left: 0.2rem;
							}
						}
						
					}
				}
				
			}
				
		}	
		
		
	}
	
</style>

<style scoped>
/deep/ .textcar_b img{
	max-width: 100%;
	vertical-align: middle
}
</style>
